var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CourseThumbBox',{attrs:{"course":_vm.course}}),_c('CourseProgressBar',{attrs:{"percent":_vm.course.attended_percent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }